import {defineCustomElement} from 'extensions/ui-utils';
import stylesheet from './x-flag.scss?as=stylesheet';
import {html, LitElement} from 'lit';

export class Flag extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	constructor () {
		super();
	}

	render () {
		return html`
			<div class="flag">
				<slot></slot>
			</div>
		`;
	}
};

defineCustomElement('x-flag', Flag);
